import styled from 'styled-components';
import { Typography, Tooltip, Button } from 'antd';

import colors from '../../styles/colors';

const { Text } = Typography;

export const TextSectiosTabs = styled(Text)`
  font-size: ${props => (props.title === 1 ? '16px' : '12px')};
  line-height: ${props => (props.title === 1 ? '19px' : '14px')};
  font-weight: ${props => (props.title === 1 ? 'bold' : 'normal')};
  margin-bottom: ${props => (props.title === 1 ? '8px' : '0')};
  color: ${props => (props.title === 1 ? colors.greyText : colors.blackText)};
`;

export const TooltipStyle = styled(Tooltip)`
  background: #ffffff;
  border: 1px solid #ebac00;
  box-sizing: border-box;
  border-radius: 22px;
  color: #ebac00;
  padding: 4.5px 16px;
  font-weight: 700;
  font-size: 12px;
  line-height: 15px;
`;

export const ButtonStyled = styled(Button)`
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  width: 96px;
  height: 32px;
  background: ${({ backgroundColorButton }) =>
    backgroundColorButton || '#24a95d'};
  color: ${({ lockButton }) => (lockButton ? '#828282' : '#fff')};
  border: none;
  border-radius: 0;
  font-weight: bold;
  font-size: 16px;
  line-height: 19px;
  &:disabled {
    color: #828282;
    cursor: not-allowed;
  }

  &:hover {
    display: flex;
    justify-content: space-between;
    align-items: center;
    cursor: pointer;
    width: 96px;
    height: 32px;
    background: ${({ backgroundColorButton }) =>
      backgroundColorButton || '#24a95d'};
    color: #fff;
    border: none;
    border-radius: 0;
    font-weight: bold;
    font-size: 16px;
    line-height: 19px;
    &:disabled {
      color: #828282;
      cursor: not-allowed;
    }
  }
`;
